import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { ORDER_CACHE_KEYS } from "./keys";

import { OrderRepository } from "@/repositories/order";

export const useGetOrder = (id: string) => {
  const orderRepository = useRef(new OrderRepository());

  return useQuery({
    queryKey: ORDER_CACHE_KEYS.GET(id),
    queryFn: async () => {
      return await orderRepository.current.findById(id);
    },
    placeholderData: keepPreviousData,
  });
};
